<template>
    <aside v-if="visible" class="conversation-history">
        <div class="conversation-history__header">
            <span class="conversation-history__title">Storico chat</span>
            <button
                type="button"
                class="conversation-history__refresh"
                aria-label="Aggiorna storico"
                :disabled="loading"
                @click="load"
            >
                ↻
            </button>
        </div>
        <p v-if="error" class="conversation-history__error">{{ error }}</p>
        <p v-else-if="loading && !items.length" class="conversation-history__empty">Caricamento…</p>
        <p v-else-if="!items.length" class="conversation-history__empty">Nessuna chat salvata.</p>
        <ul v-else class="conversation-history__list">
            <li
                v-for="item in items"
                :key="item.id"
                class="conversation-history__item"
                :class="{ 'conversation-history__item--active': item.id === activeId }"
            >
                <button type="button" class="conversation-history__button" @click="$emit('select', item)">
                    <span class="conversation-history__item-title">{{ item.title || 'Chat senza titolo' }}</span>
                    <span v-if="item.agent_slug" class="conversation-history__item-agent">{{ item.agent_slug }}</span>
                    <span class="conversation-history__item-date">{{ formatDate(item.updated_at) }}</span>
                </button>
            </li>
        </ul>
    </aside>
</template>

<script>
export default {
    name: 'ConversationHistory',
    props: {
        endpoint: {
            type: String,
            required: true,
        },
        visible: {
            type: Boolean,
            default: true,
        },
        activeId: {
            type: String,
            default: '',
        },
        refreshToken: {
            type: Number,
            default: 0,
        },
    },
    emits: ['select'],
    data() {
        return {
            items: [],
            loading: false,
            error: null,
        };
    },
    watch: {
        visible(value) {
            if (value) {
                this.load();
            }
        },
        refreshToken() {
            if (this.visible) {
                this.load();
            }
        },
    },
    mounted() {
        if (this.visible) {
            this.load();
        }
    },
    methods: {
        async load() {
            this.loading = true;
            this.error = null;

            try {
                const response = await fetch(this.endpoint, {
                    headers: {
                        Accept: 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                });

                if (!response.ok) {
                    throw new Error(`Request failed (${response.status})`);
                }

                const payload = await response.json();
                this.items = payload.data || [];
            } catch (e) {
                this.error = 'Impossibile caricare lo storico.';
                this.items = [];
            } finally {
                this.loading = false;
            }
        },
        formatDate(value) {
            if (!value) {
                return '';
            }

            try {
                return new Intl.DateTimeFormat('it-IT', {
                    dateStyle: 'short',
                    timeStyle: 'short',
                }).format(new Date(value));
            } catch (e) {
                return value;
            }
        },
    },
};
</script>

<style scoped>
.conversation-history {
    width: 220px;
    flex: 0 0 220px;
    border-right: 1px solid #e2e8f0;
    background: #f8fafc;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.conversation-history__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    border-bottom: 1px solid #e2e8f0;
}

.conversation-history__title {
    font-size: 12px;
    font-weight: 600;
    color: #0f172a;
}

.conversation-history__refresh {
    border: none;
    background: transparent;
    cursor: pointer;
    font-size: 16px;
    color: #475569;
}

.conversation-history__list {
    list-style: none;
    margin: 0;
    padding: 8px;
    overflow-y: auto;
    flex: 1 1 auto;
}

.conversation-history__item {
    margin-bottom: 4px;
}

.conversation-history__button {
    width: 100%;
    text-align: left;
    border: 1px solid transparent;
    border-radius: 8px;
    background: #fff;
    padding: 8px;
    cursor: pointer;
}

.conversation-history__item--active .conversation-history__button {
    border-color: #94a3b8;
    background: #e2e8f0;
}

.conversation-history__item-title {
    display: block;
    font-size: 12px;
    font-weight: 600;
    color: #0f172a;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.conversation-history__item-agent,
.conversation-history__item-date {
    display: block;
    font-size: 11px;
    color: #64748b;
}

.conversation-history__empty,
.conversation-history__error {
    padding: 12px;
    font-size: 12px;
    color: #64748b;
    margin: 0;
}

.conversation-history__error {
    color: #b91c1c;
}
</style>
